import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  deletePaper: {
    backgroundColor: theme.palette.background.default,
    margin: 'auto',
    width: '40%',
    maxWidth: 500,
    padding: 24,
    marginTop: '15vh',
    zIndex: 1,
    outline: 'none',
    position: 'relative',
    borderRadius: 16,
    [theme.breakpoints.down('sm')]: {
      width: '90%',
      marginTop: '10vh',
      marginBottom: '10vh'
    }
  },
  deleteButton: {
    marginLeft: 8
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 36
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: 16
  },
  space: {
    marginBottom: 8
  },
  spaceCenter: {
    textAlign: 'center'
  },
  inputWithLable: {
    marginTop: 8,
    width: '100%'
  },
  circularProgress: {
    marginLeft: 8,
    color: theme.palette.primary.main
  },
  itemsBox: {
    padding: '10px 16px',
    margin: '20px 0px',
    border: '1px solid #e7e7e7',
    borderRadius: 16,
    height: 'calc(100vh - 750px)',
    minHeight: 250,
    position: 'relative'
  },
  listView: {
    height: '100%',
    overflowY: 'auto'
  },
  listRow: {
    display: 'flex',
    justifyContent: 'center',
    background: theme.palette.grey[100],
    padding: 12,
    borderRadius: 8,
    marginBottom: 8,
    cursor: 'pointer',
    border: '1px solid transparent',
    boxSizing: 'border-box'
  },
  selectedListRow: {
    borderColor: 'black'
  },
  skeletonContainer: {
    display: 'grid',
    gridTemplateRows: '1fr 1fr 1fr 1fr 1fr'
  },
  skeleton: {
    height: 36,
    marginBottom: 8,
    borderRadius: 12
  }
}))

export default useStyles
